import path from 'path';
import { parentPath, parsePath } from '@truqc/content-path';
import { createHashHistory } from 'history';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { enabledSelector, hasAnnotationsSelector, newPathSelector } from '../selectors/index';
import pendingChangesSelector from '../selectors/pendingChangesSelector';
import entityComposition from '../../common/classes/entityComposition';
import Icon from '../../common/containers/icon';
import Label from './label';
const hashHistory = createHashHistory();
class EditDocumentButton extends Component {
  constructor(props) {
    super(props);
    this.loadReportDocumentEditor = this.loadReportDocumentEditor.bind(this);
  }
  loadReportDocumentEditor() {
    const {
      path: rawParentPath,
      reduxEntity,
      formID,
      pendingChanges,
      notificationActions: {
        info
      }
    } = this.props;
    if (pendingChanges) {
      info({
        rightButtonLabel: 'Ok',
        id: 'stop_navigation',
        message: `There are pending changes for this ${reduxEntity}, please save before attempting to edit a document.`
      });
      return;
    }
    const parentContentPath = parentPath(rawParentPath);
    const pathArray = parsePath(parentContentPath);
    if (reduxEntity === 'report') {
      const reportDocumentID = pathArray[pathArray.length - 1];
      const url = path.join('/reportDocuments/edit', reportDocumentID);
      hashHistory.push(url);
    } else if (reduxEntity === 'form' && formID !== undefined) {
      const formDocumentID = pathArray[pathArray.length - 1];
      const url = `/formDocuments/edit/${formID}/${formDocumentID}`;
      hashHistory.push(url);
    }
  }
  render() {
    const {
      enabled,
      hasAnnotations,
      title,
      testingIdentifier
    } = this.props;
    const classes = classNames({
      [kebabCase(testingIdentifier)]: true,
      't-rb-edp-bo': true,
      'tqc-control': true
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null), /*#__PURE__*/React.createElement(Button, {
      block: true,
      className: classes,
      onClick: this.loadReportDocumentEditor,
      disabled: !enabled
    }, hasAnnotations ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      glyph: "pencil-alt",
      className: "t-rb-remove-button-has-annotations-icon"
    }), "\xA0\xA0") : '', title));
  }
}
EditDocumentButton.defaultProps = {
  testingIdentifier: 'default-id',
  formID: null
};
EditDocumentButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  pendingChanges: PropTypes.bool.isRequired,
  hasAnnotations: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  testingIdentifier: PropTypes.string,
  title: PropTypes.string.isRequired,
  formID: PropTypes.string,
  reduxEntity: PropTypes.string.isRequired,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired
};
export { EditDocumentButton as UncomposedEditDocumentButton };
export default entityComposition(EditDocumentButton, [], {
  enabled: enabledSelector,
  hasAnnotations: hasAnnotationsSelector,
  path: newPathSelector,
  pendingChanges: pendingChangesSelector,
  formID: state => state.form.active ? state.form.active.id : null
}, ['notification']);